import { HttpResponse } from '@/utils/http-utils';
import siteConfigService from '@/services/site.config.service';
import SSOToken from '@/entities/ssokoken';
import { Credential } from '@/entities/credential';
import storageService from '@/services/storage.service';
import httpService from '@/services/http.service';
import JSONUtils from '@/utils/json-utils';
import Logger from '@/utils/logger.utils';
import { commonService, UserInfoContext, userService } from '@ol/ol-ui-core';


class LoginService {
  private ssotokenserviceApiEndpointKeyName: string = 'auth.ssoTokenServiceUrl';
  public async login(credential: Credential): Promise<SSOToken> {
    const username: string[] = [credential.username];
    const password: string[] = [credential.password];

    let loginAPIEndpoint: string = await siteConfigService.getApiEndpoint('auth.ssoTokenServiceUrl', {
      username,
      password,
    });
    loginAPIEndpoint = loginAPIEndpoint.replace('plssoservice', 'ssotokenservice');
    const siteConfigurationRes: HttpResponse<SSOToken> = await (httpService.get<SSOToken>(loginAPIEndpoint));
    let ssoToken: SSOToken = siteConfigurationRes.data;
    if (!!ssoToken && !!ssoToken.error) {
      throw new Error(ssoToken.error);
    }
    if (typeof ssoToken === 'string') {
      ssoToken = JSONUtils.parse(ssoToken);
    }
    if (ssoToken.userid) {
      ssoToken.userid = Number(ssoToken.userid);
    }
    return ssoToken;
  }

  private currentSelectdOrg: string = 'organization.currentSelectedOrg';
  public async saveStdplCurrentSelectedOrg(): Promise<void> {
    const plId: number = await storageService.getPrivateLabelId();
    const currentSelOrg: string = await siteConfigService.getApiEndpoint(this.currentSelectdOrg);

    if (currentSelOrg != null) {
      const currentOrgHttpService: HttpResponse<any> = await (httpService.get<any>(currentSelOrg));
      const currentOrgData: any = currentOrgHttpService.data;
      const currentOrg: string = currentOrgData.toString().trim();

      let selectedOrg: number = 0;

      const selectedOrgElements = currentOrg.split(';');
      selectedOrgElements.forEach((item) => {
        if (item.indexOf('currentSelectedOrg') > -1) {
          const selectedOrgData = item.split('=');
          if (selectedOrgData !== undefined && selectedOrgData.length > 0) {
            selectedOrg = Number(selectedOrgData[1]);
          }
        }
      });

      await commonService.getOrGenerateCommonProperties(plId, selectedOrg, null, null, null);
    }
  }

  public async getJState(): Promise<string> {
    const plId: number = await storageService.getPrivateLabelId();
    const ssoToken: string = await userService.getSsoToken(plId);
    const jstate = await userService.getJState(plId, ssoToken);
    return jstate;
  }

  private dummyString: string = '';
  public async isLoggedIn(): Promise<boolean> {
    const hasSiteInfoInStorage: boolean = await storageService.hasSiteInfoInStorage();
    if (!hasSiteInfoInStorage) {
      return false;
    }

    const plId: number = await storageService.getPrivateLabelId();
    Logger.ignore(this.dummyString);
    let hasSSOToken: boolean = await userService.hasSsoToken(plId);
    if (!hasSSOToken) {
      const jstate:boolean = await userService.hasJState(plId);

      if (jstate) {
        hasSSOToken = true;
      }
    }
    return hasSSOToken;
  }

  public async hasCurrentOrg(): Promise<boolean> {
    const hasSiteInfoInStorage: boolean = await storageService.hasSiteInfoInStorage();
    if (!hasSiteInfoInStorage) {
      return false;
    }
    Logger.ignore(this.dummyString);
    const plId: number = await storageService.getPrivateLabelId();
    const hasCurrentOrgId: boolean = await userService.getCurrentOrgId(plId) > 0;

    return hasCurrentOrgId;
  }

  public async getJstateFromLoginApi(): Promise<string> {
    let loginAPIEndpoint: string = await siteConfigService.getApiEndpoint('auth.imolaLoginJSONAPI');
    const plId: number = await storageService.getPrivateLabelId();
    const currentOrgId: number = await userService.getCurrentOrgId(plId);
    if (plId) {
      loginAPIEndpoint = loginAPIEndpoint.replace('{plId}', `${plId}`);
    }
    if (currentOrgId) {
      loginAPIEndpoint = loginAPIEndpoint.replace('{orgId}', `${currentOrgId}`);
    }
    try {
      const loginAPIResponse: HttpResponse = await httpService.get(loginAPIEndpoint);
      const responseWithOutSpaces: string = loginAPIResponse.data.toString().trim().replace(/\s/g, '');
      if (responseWithOutSpaces.indexOf('SUCCESS') !== -1) {
        const jstate: string = responseWithOutSpaces.substring(responseWithOutSpaces.indexOf("_jstate:'") + 9, responseWithOutSpaces.lastIndexOf("'"));
        return jstate;
      }
    } catch (error) {
      Logger.info(`Error occured while  geting Jstate from Login API ${error}`);
    }
    return '';
  }
}

// Export a singleton instance in the global namespace
export const loginService = new LoginService();
